<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
  import VoucherService from 'src/services/VoucherService'
  import NavList from "../../../../components/List/NavList";
  import get from "lodash/get";
  import {mapMutations} from "vuex";
  import voucherModule from "../../../../store/modules/vouchers";
  import {entities, getRouteName, routeTypes} from "../../../../config/routeTypes";
  export default {
    name: 'voucher-details',
    computed: {
      voucher () {
        return this.$store.state.vouchers.currentVoucher || {}
      },
    },
    methods: {
      get,
      ...mapMutations('vouchers', [voucherModule.types.SET_CURRENT_VOUCHER]),
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id;
        let res = await VoucherService.getById(id, {
          with: 'orders'
        });
        let cms = res.data;
        if (cms) {
          next(vm => {
            vm.$store.commit('vouchers/SET_CURRENT_VOUCHER', cms)
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    }

  }
</script>
